import { render, staticRenderFns } from "./DeleteVirtualVisit.vue?vue&type=template&id=2c492078"
import script from "./DeleteVirtualVisit.vue?vue&type=script&lang=js"
export * from "./DeleteVirtualVisit.vue?vue&type=script&lang=js"
import style0 from "./DeleteVirtualVisit.vue?vue&type=style&index=0&id=2c492078&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports